var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmarkCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Checkmark-Circle-2/Line",
    transform: "translate(-2.000000, -2.000000)",
    fill: "#28ABB9"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.9999996,2 L12.2799045,2.0038418 C17.6733312,2.15206821 21.9999996,6.57075806 21.9999996,12 L21.9999996,12 L21.9961578,12.279905 C21.8479314,17.6733316 17.4292419,22 11.9999996,22 C6.47714956,22 1.99999956,17.52285 1.99999956,12 C1.99999956,6.47715 6.47714956,2 11.9999996,2 L11.9999996,2 Z M11.9999997,4 C7.58171965,4 3.99999965,7.58172 3.99999965,12 C3.99999965,16.41828 7.58171965,20 11.9999997,20 L11.9999997,20 L12.2491791,19.9961932 C16.5521638,19.8645429 19.9999997,16.3349162 19.9999997,12 L19.9999997,12 L19.9961928,11.7508206 C19.8645426,7.44783584 16.3349159,4 11.9999997,4 Z M14.7727496,8.29440243 C15.1228894,7.93758173 15.6921589,7.88902093 16.1000001,8.2 C16.5418281,8.53689 16.6268941,9.168172 16.2900001,9.61 L16.2900001,9.61 L11.7200001,15.61 C11.5312071,15.855247 11.2394971,15.9992561 10.9300001,16.0000146 L10.9300001,16.0000146 L10.7993428,15.9921547 C10.541016,15.9595427 10.3035617,15.8269932 10.14,15.62 L10.14,15.62 L7.71000003,12.51 L7.71000003,12.51 L7.63901098,12.4061124 C7.38451695,11.978632 7.48225695,11.4185277 7.88500003,11.105 C8.32130503,10.765345 8.95034503,10.843695 9.29000003,11.28 L9.29000003,11.28 L10.92,13.39 L14.7,8.39 L14.6900001,8.39000002 L14.6900001,8.39000002 Z",
    id: "Fill"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkCircle);
export default __webpack_public_path__ + "static/media/checkmark-circle.1c1e6e302ebfe28e244460ca272ef200.svg";
export { ForwardRef as ReactComponent };